import axios from "axios";
import onboardingServiceConfig from "./onboardingServiceConfig";

export const getAllSections = () =>
  axios.get(`${onboardingServiceConfig.getAllSections}`);
export const getSectionById = (params) =>
  axios.get(`${onboardingServiceConfig.getSectionById}`, { params });
export const createSection = (params) =>
  axios.post(`${onboardingServiceConfig.getSectionById}`, params);
export const removeSection = (id) =>
  axios.delete(`${onboardingServiceConfig.getSectionById}?sectionId=${id}`);
export const updateSection = (params) =>
  axios.patch(`${onboardingServiceConfig.getSectionById}`, params);
export const reorderSection = (params) =>
  axios.patch(`${onboardingServiceConfig.reorderSections}`, params );
export const createUpdateSectionProgress = (params) =>
  axios.post(`${onboardingServiceConfig.createRemoveSectionProgress}`, {
    params,
  });
export const getUserSectionWithProgress = (params) =>
  axios.get(`${onboardingServiceConfig.getUserSectionWithProgress}`, {
    params,
  });
export const getAllSectionProgress = () =>
  axios.get(`${onboardingServiceConfig.allSectionProgress}`);
export const getSectionProgressByUser = (userId, facebookUserId) =>
  axios.get(`${onboardingServiceConfig.sectionProgressByUser}?userId=${userId}&facebookUserId=${facebookUserId}`);
export const getUserProgressBySection = (sectionId) =>
  axios.get(`${onboardingServiceConfig.userProgressBySection}?sectionId=${sectionId}`);
